import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { AppLoader } from "../../Components/common/AppLoader/AppLoader";
import { HospitalCard } from "../../Components/ui/HospitalCard/HospitalCard";
import { usePartnerHospitals } from "../../hooks/usePartnerHospitals";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import "../home/partnerhospitals/partnerhospitals.css";
import "./hospitalspartners.css";

export const Hospitalspartners = () => {
  const {
    countries,
    locationTabs,
    selectedCountry,
    activeLocation,
    setActiveLocation,
    handleCountrySelect,
    filteredHospitals,
    loading,
    error,
  } = usePartnerHospitals();

  return (
    <>
      <section
        className="hp-hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Hospitals Partners</p>
            <h1 className="hp_hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      <section className="hp-section">
        <Container fluid className="hp-container">
          <div className="partner-hospitals__top">
            <div>
              <h2 className="partner-hospitals__title">Partner Hospitals</h2>
              <p className="partner-hospitals__subtitle">
                World-class healthcare institutions with advanced facilities and
                trusted care.
              </p>
            </div>
          </div>

          <div className="partner-hospitals__filter-row">
            <div className="partner-hospitals__tabs-wrap">
              <div className="partner-hospitals__tabs">
                {locationTabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`partner-hospitals__tab ${activeLocation?.id === tab.id ? "partner-hospitals__tab--active" : ""}`}
                    onClick={() => setActiveLocation(tab)}
                  >
                    {tab.name}
                  </button>
                ))}
              </div>
            </div>

            <Dropdown
              className="partner-hospitals__country-dropdown"
              onSelect={handleCountrySelect}
            >
              <Dropdown.Toggle className="partner-hospitals__country-toggle">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                {selectedCountry?.name || "Select Country"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="partner-hospitals__country-menu">
                {countries.map((country) => (
                  <Dropdown.Item
                    key={country.id}
                    eventKey={String(country.id)}
                    active={selectedCountry?.id === country.id}
                  >
                    {country.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {loading && (
            <AppLoader className="py-5" />
          )}

          {!loading && error && (
            <p className="text-center py-4 text-danger">{error}</p>
          )}

          {!loading && !error && (
            <Row className="g-4 mt-2">
              {filteredHospitals.length > 0 ? (
                filteredHospitals.map((hospital) => (
                  <Col key={hospital.id} xs={12} sm={6} lg={4}>
                    <HospitalCard {...hospital} />
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <p className="text-center py-4">No hospitals found for the selected filters.</p>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};
